// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_landing_sign_in_with_google_button = /** @type {(inputs: {}) => string} */ () => {
	return `Sign in with Google`
};

const id_landing_sign_in_with_google_button = /** @type {(inputs: {}) => string} */ () => {
	return `Masuk dengan Google`
};

const ja_landing_sign_in_with_google_button = /** @type {(inputs: {}) => string} */ () => {
	return `Googleでログイン`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const landing_sign_in_with_google_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing_sign_in_with_google_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing_sign_in_with_google_button", locale)
	if (locale === "en") return en_landing_sign_in_with_google_button(inputs)
	if (locale === "id") return id_landing_sign_in_with_google_button(inputs)
	return ja_landing_sign_in_with_google_button(inputs)
};
export { landing_sign_in_with_google_button as "landing.sign_in_with_google_button" }